<template lang="html">
    <b-navbar class="fixed-top" toggleable="md" type="dark" variant="info">
        <div class="text-center navbar-brand-wrapper d-flex align-items-top justify-content-center">
            <a class="navbar-brand brand-logo" href="/"><img src="../../assets/images/mt-logo.png" alt="logo"/></a>
            <a class="navbar-brand brand-logo-mini" href="/"><img src="../../assets/images/logo-mini.svg" alt="logo"/></a>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-center ml-auto ml-lg-0">
            <b-navbar-nav class="header-links d-none d-md-flex">
                <b-nav-item href="/images" :active="$route.path === '/images'"><i class="mdi mdi-image-filter"></i>{{ $t("forms.images") }}
                </b-nav-item>
                <b-nav-item href="/files" :active="$route.path === '/files'"><i class="mdi mdi-file-document"></i>{{ $t("forms.files") }}
                </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right class="preview-list">
                    <template slot="button-content">
                        <img src="../../assets/images/mt-generic-user.png" alt="profile image" class="img-xs">
                    </template>
                    <b-dropdown-item v-on:click="logout" class="preview-item flex-wrap">{{ $t('logout') }}</b-dropdown-item>
                    <b-dropdown-item v-on:click="changePasswordModal" class="preview-item flex-wrap">{{ $t('changePassword') }}</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
            <button class="navbar-toggler navbar-toggler-right align-self-center" type="button" @click="collapedMobileSidebar()">
                <span class="mdi mdi-menu"></span>
            </button>
        </div>
        <b-modal id="change-password-modal" ref="modal" :title="$t('changePassword')" @ok="changePassword" :ok-disabled="!isValid" size="lg" v-model="passwordModalVisible">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <b-form-group :label="$t('newPassword')" label-for="password-input">
                            <b-form-input v-model="newPassword" id="password-input" type="password"/>
                        </b-form-group>
                        <b-form-group :label="$t('newPasswordRepeat')"  label-for="password-repeat-input">
                            <b-form-input v-model="newPasswordRepeat" id="password-repeat-input" type="password"/>
                        </b-form-group>

                        <div id="message">
                          <p id="length" :class="lengthClass">{{ $t('passwordRules.length') }}</p>
                          <p id="letter" :class="letterClass">{{ $t('passwordRules.lower') }}</p>
                          <p id="capital" :class="capitalClass">{{ $t('passwordRules.upper') }}</p>
                          <p id="number" :class="numberClass">{{ $t('passwordRules.digit') }}</p>
                          <p id="same" :class="sameClass">{{ $t('passwordRules.match') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </b-navbar>
</template>

<script lang="js">
import axios from "axios";
import {Const} from "@/config";
import jwtService from "@/mixins/JwtStorageService";

export default {
    name: 'app-header',
    data() {
        return {
            newPassword: '',
            newPasswordRepeat: '',
            newPasswordValid: false,
            changePasswordRequired: false,
            passwordModalVisible: false,
            reminderInterval: null,
        }
    },
    computed: {
        letterClass() {
            return /[a-z]/.test(this.newPassword) ? 'valid' : 'invalid';
        },
        capitalClass() {
            return /[A-Z]/.test(this.newPassword) ? 'valid' : 'invalid';
        },
        numberClass() {
            return /[0-9]/.test(this.newPassword) ? 'valid' : 'invalid';
        },
        lengthClass() {
            return this.newPassword.length >= 12 ? 'valid' : 'invalid';
        },
        sameClass() {
            return this.newPassword !== "" && this.newPassword === this.newPasswordRepeat ? 'valid' : 'invalid';
        },
        isValid() {
            return this.letterClass === 'valid' && this.capitalClass === 'valid' && this.numberClass === 'valid' && this.lengthClass === 'valid' && this.sameClass === 'valid';
        }
    },
    mounted() {
        if (!jwtService.isPasswordChangeRequiredSet()) {
            axios.get(Const.API_HOST + '/admin/users/changePasswordRequired')
                .then(response => {
                    jwtService.setPasswordChangeRequired(response.data.code === 1)
                    this.startPasswordReminder()
                }).catch(error => {
                    // eslint-disable-next-line no-console
                    console.error(error)
                })
        } else if (jwtService.isPasswordChangeRequired()) {
            this.startPasswordReminder()
        }
    },
    beforeDestroy() {
        if (this.reminderInterval) {
            clearInterval(this.reminderInterval)
        }
    },
  methods: {
        startPasswordReminder() {
            if (this.reminderInterval || !jwtService.isPasswordChangeRequired()) {
                return
            }
            this.reminderInterval = setInterval(() => {
                if (jwtService.isPasswordChangeRequired() && !this.passwordModalVisible) {
                    this.$bvModal.show('change-password-modal');
                }
            }, 5000);
        },
        collapedMobileSidebar: () => {
            document.querySelector('.sidebar').classList.toggle('active')
        },
        logout() {
            this.$store.dispatch('logout');
        },
        changePasswordModal() {
            this.$bvModal.show('change-password-modal')
        },
        changePassword() {
            this.newPasswordValid = this.isValid;
            if (this.newPasswordValid) {
                let app = this;
                axios.post(Const.API_HOST + '/admin/users/changePassword', {
                    email: jwtService.getUsername(),
                    password: this.newPassword
                }).then(function (response) {
                  if (response.status === 200) {
                    app.$store.dispatch('logout');
                    window.location.href = '/login?passwordChanged=true';
                  }
                }).catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.error(error)
                })
            }
            if (this.newPasswordValid) {
                this.$bvModal.hide('change-password-modal');
            }
        }
    }
}
</script>

<style scoped lang="scss">
#message p {
    font-size: small;
    padding-left: 2em;
    line-height: 0.1em;
}

#message .valid {
    color: green;
}

#message .valid:before {
    position: relative;
    left: -10px;
    content: "✔";
}

#message .invalid {
    color: red;
}

#message .invalid:before {
    position: relative;
    left: -10px;
    content: "✖";
}
</style>
